<template>
  <div class="auth">
    <router-view></router-view>
  </div>
</template>
<script>
export default {};
</script>
<style lang="css"></style>
